var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCohort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M13.95 19.503c.445.209.935.334 1.46.334.448 0 .874-.092 1.266-.25l.193-.084h.176c1.301 0 2.367.991 2.45 2.243l.005.157v.6c0 .516-.4.94-.911.994l-.112.006h-6.136c-.527 0-.961-.39-1.017-.89l-.006-.11v-.6c0-1.272 1.013-2.313 2.293-2.395l.162-.005h.177zM6.924 5.5a1.166 1.166 0 110 2.333l-1.561-.001v10.334h1.561c.602 0 1.097.456 1.16 1.04l.007.127c0 .645-.522 1.167-1.167 1.167H4.167A1.166 1.166 0 013 19.333V6.667C3 6.022 3.522 5.5 4.167 5.5zm8.485 8.67c1.319 0 2.386 1.044 2.386 2.333 0 1.29-1.067 2.334-2.386 2.334-1.319 0-2.386-1.044-2.386-2.334s1.067-2.333 2.386-2.333zm-1.46-8.337c.446.209.936.334 1.46.334.45 0 .875-.092 1.267-.25l.193-.084h.176c1.301 0 2.367.991 2.45 2.243l.005.157v.6c0 .516-.4.94-.911.994l-.112.006h-6.136c-.527 0-.961-.39-1.017-.89l-.006-.11v-.6c0-1.272 1.013-2.313 2.293-2.395l.162-.005h.177zM15.41.5c1.319 0 2.386 1.044 2.386 2.333 0 1.29-1.067 2.334-2.386 2.334-1.319 0-2.386-1.044-2.386-2.334S14.09.5 15.409.5z"
  }))));
}

export default SvgCohort;